import Lista from './Lista';

export const ArquivoLista = Lista;
